module.exports = __webpack_public_path__ + "static/media/placeholder-protected-fr.75d04099.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-protected-fr.svg
// module id = 853
// module chunks = 1